import React, {useState} from 'react';
import styles from './AppBar.module.css';
import useDismissableMenu from './useDismissableMenu';
import {MenuPanel, MenuLink, MenuDivider, MenuLabel} from './MenuPanel';
import {ChevronDownIcon} from '../marketing/icons/Icons';

const initialsOf = (authentication) => {
    const name = authentication?.name;
    if (name) {
        const parts = name.trim().split(/\s+/);
        return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || name[0].toUpperCase();
    }
    // Falls back to this when Cognito doesn't return a name claim (e.g. the
    // profile scope isn't granted) - still better than a bare "?".
    const email = authentication?.email;
    return email ? email[0].toUpperCase() : '?';
};

// The account avatar button in the app bar: a 32px initials circle inside a
// 44px tap target, opening a menu with organisation/admin/sign-out links.
// Consolidates what Header.js previously spread across separate nav dropdowns.
const AccountMenu = ({authentication}) => {
    const [open, setOpen] = useState(false);
    const {triggerRef, menuRef} = useDismissableMenu(open, () => setOpen(false));

    return (
        <div className={styles.accountWrap}>
            <button
                ref={triggerRef}
                type="button"
                aria-label="Profile menu"
                aria-haspopup="menu"
                aria-expanded={open}
                className={styles.avatarButton}
                onClick={() => setOpen((o) => !o)}
            >
                <span className={styles.avatar}>{initialsOf(authentication)}</span>
                <ChevronDownIcon className={styles.avatarChevron}/>
            </button>
            {open && (
                <MenuPanel ref={menuRef} label="Profile menu">
                    <MenuLabel>{authentication?.name || authentication?.email}</MenuLabel>
                    {authentication?.organisation ? (
                        <MenuLink to={`/organisations/${authentication.organisation.id}`}>
                            {authentication.organisation.name}
                        </MenuLink>
                    ) : (
                        <MenuLink to="/createOrganisation">Create organisation</MenuLink>
                    )}
                    {authentication?.features?.admin && <MenuLink to="/admin">Admin</MenuLink>}
                    <MenuDivider/>
                    <MenuLink to="/logout">Sign out</MenuLink>
                </MenuPanel>
            )}
        </div>
    );
};

export default AccountMenu;
